/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PruefplanIdentifier { 
    pruefplan_id: string;
    pruefcheckliste_id: string;
    pruefobjekt_id: string;
    pruefaufgabe_id: string;
    antwort_id: string;
    mandant_id: string;
    modified_on_utc: Date;
}

